<template>
  <div>
    <el-dialog
      title="确定核销?"
      :visible.sync="visible" width="650px"
      :before-close="cancel"
      v-loading="loading">
      <el-form>
        <el-form-item label="收付金额">
          {{pay_info.pay_total}}
        </el-form-item>
        <el-form-item label="缴费时间">
          <span style="color:red">{{pay_info.date}}</span>
        </el-form-item>
        <el-form-item label="结算方式" v-if="pay_info.pay_name">
          <span>{{pay_info.pay_name}}</span>
        </el-form-item>
        <el-form-item v-if="needAssociateFlow">
          <el-button type="warning" size="small" @click="openCbsFlowDialog">
            关联CBS流水 ({{ selected_flows.length }})
          </el-button>
          <span v-if="selected_flows.length > 0" style="margin-left: 10px; color: #67c23a;">
            已选流水总额: {{ selected_flow_total }}
          </span>
          <a href="https://crm.gdzawy.com:9000/#/new/detail?news_id=174" target="_blank">教程说明</a>
        </el-form-item>
        <el-form-item label="同时开发票">
          <el-select v-model="invoice_select" @change="handleInvoiceSelect">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票信息" v-if="invoice_select">
          <el-descriptions v-if="invoice_select && invoiceForm.move_type === 1" title="" :column="2" border>
            <el-descriptions-item label="操作类型">
              <span >开具发票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票类型">
              <span v-if="invoiceForm.invoice_type == '82'">电子普票</span>
              <span v-else>电子专票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票抬头">
              {{invoiceForm.title}}
            </el-descriptions-item>
            <el-descriptions-item label="纳税人识别号">
              {{invoiceForm.taxNo}}
            </el-descriptions-item>
            <el-descriptions-item label="是否不动产">
              <span v-if="invoiceForm.taxAddressType === 0">否</span>
              <span v-else>是</span>
            </el-descriptions-item>
            <el-descriptions-item v-if="invoiceForm.taxAddressType === 1" label="不动产所在省市">
              {{invoiceForm.realEstatePlace}}
            </el-descriptions-item>
            <el-descriptions-item v-if="invoiceForm.taxAddressType === 1" label="不动产详细地址">
              {{invoiceForm.fullAddress}}
            </el-descriptions-item>
            <el-descriptions-item label="购方地址">
              {{invoiceForm.address}}
            </el-descriptions-item>
            <el-descriptions-item label="开户行">
              {{invoiceForm.bank}}
            </el-descriptions-item>
            <el-descriptions-item label="银行账号">
              {{invoiceForm.bankAccount}}
            </el-descriptions-item>
            <el-descriptions-item label="电话">
              {{invoiceForm.phone}}
            </el-descriptions-item>
            <el-descriptions-item label="邮箱">
              {{invoiceForm.email}}
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              {{invoiceForm.remark}}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions v-if="invoice_select && invoiceForm.move_type === 2" title="" :column="2" border>
            <el-descriptions-item label="操作类型">
              <span >补录发票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票类型">
              <span v-if="invoiceForm.invoice_type == '82'">电子普票</span>
              <span v-else>电子专票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票号">
              {{invoiceForm.invoice_no}}
            </el-descriptions-item>
            <el-descriptions-item label="开票前金额">
              {{invoiceForm.invoice_total}}
            </el-descriptions-item>
            <el-descriptions-item label="开票金额">
              {{invoiceForm.tax_total}}
            </el-descriptions-item>
            <el-descriptions-item label="开票日期">
              {{invoiceForm.invoice_date}}
            </el-descriptions-item>
          </el-descriptions>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sendMoneyPay" :disabled="isConfirmButtonDisabled">确认收付</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <electronic-invoice-form :order_type="'paid_order'" ref="moneyPay_invoiceFormRef"
                             @close="handleCloseInvoice" :send_method="false"
                             @sendInvoice="handleInvoiceInput">
    </electronic-invoice-form>

    <!-- CBS流水选择器组件 -->
    <cbs-flow-selector
      :visible.sync="cbs_flow_dialog_visible"
      :pindex-id="pindex_id"
      :pay-amount="parseFloat(pay_info.pay_total || 0)"
      @confirm="handleFlowConfirm"
      @close="cbs_flow_dialog_visible = false"
    />

    <!-- CBS流水详情组件 -->
    <cbs-flow-detail
      :visible.sync="flow_detail_visible"
      :flow-data="current_flow_row"
      @close="flow_detail_visible = false"
    >
    </cbs-flow-detail>
  </div>
</template>

<script>
import ElectronicInvoiceForm from "@/components/Admin/Order/order/electronicInvoiceForm.vue";
import CbsFlowDetail from "@/components/Admin/Order/order/CbsFlowDetail.vue";
import CbsFlowSelector from '../component/CbsFlowSelector.vue';

export default {
  name: 'moneyPay',
  data() {
    return {
      loading : false,
      invoice_select : false,
      invoiceForm : {},
      // CBS流水相关
      has_cbs_config : false,
      cbs_flow_dialog_visible : false,
      selected_flows : [],
      cbs_flow_list : [],
      cbs_flow_loading : false,
      sync_date_range : [],
      syncing : false,
      flow_filter : {
        timeRange : [],
        account_no : '',
        bank_type : ''
      },
      cbs_pagination : {
        page : 1,
        pageSize : 20,
        total : 0
      },
      cbs_config_checking : false,
      isConfirmButtonDisabled : false,
      bankTypeOptions : [], // 银行类型选项列表
      flow_detail_visible : false, // 流水详情对话框
      current_flow_row : null // 当前查看的流水行
    }
  },
  props : {
    visible : {
       type : Boolean , default : false
    },
    pay_info : {
      type : Object , default : {}
    },
    pay_method : {
      type : [String, Number], default : ''
    },
    pindex_id : {
      type : [String, Number], default : 0
    }
  },
  watch: {
    visible(val){
      if(!val){
        this.invoice_select = false;
        this.invoiceForm = {};
        // 清空CBS相关数据
        this.selected_flows = [];
        this.cbs_flow_list = [];
        this.has_cbs_config = false;
      }else{
        // 打开核销弹框
        this.isConfirmButtonDisabled = false;
        // 检查项目是否配置CBS账号
        if(this.isTransferPayment()){
          this.isConfirmButtonDisabled = true;

          if(this.checkCbsConfig()){
            this.isConfirmButtonDisabled = false;
          }
          console.log(this.isConfirmButtonDisabled)
        }
      }
    }
  },
  computed: {
    // 是否需要关联CBS流水
    needAssociateFlow() {
      return this.has_cbs_config && this.isTransferPayment();
    },
    // 已选流水总额（单选）
    selected_flow_total() {
      if (!this.selected_flows || this.selected_flows.length === 0) {
        return 0;
      }
      const flowId = this.selected_flows[0];
      const flow = this.cbs_flow_list.find(f => f.id === flowId);
      if (flow) {
        return (parseFloat(flow.incurred_amount) - parseFloat(flow.reconciled_amount)).toFixed(2);
      }
      return 0;
    },
  },
  created() {

  },
  methods: {
    // 判断是否为转账支付方式
    isTransferPayment() {
      if (this.pay_info && this.pay_info.pay_name) {
        return this.pay_info.pay_name === '转账';
      }
      // 如果没有pay_name，暂时返回false，需要父组件传递支付方式列表
      return false;
    },
    // 检查项目是否配置CBS账号
    checkCbsConfig() {
      if (!this.pindex_id) {
        return false;
      }
      // 设置检查中状态
      this.cbs_config_checking = true;

      this.$myhttp.post('admin/cbs/checkProjectCbsConfig', {
        pindex_id: this.pindex_id
      }, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.cbs_config_checking = false;
        if (res.data.code === 200) {
          this.has_cbs_config = res.data.data.has_config;
          // 如果是转账且需要关联流水（有CBS配置），禁用按钮等待用户选择
          if(this.isTransferPayment() && this.has_cbs_config){
            this.isConfirmButtonDisabled = true;
          } else {
            // 没有CBS配置或非转账，启用按钮
            this.isConfirmButtonDisabled = false;
          }
        }
      }).catch(err => {
        this.cbs_config_checking = false;
        this.isConfirmButtonDisabled = false;
      });
    },
    // 处理流水确认
    handleFlowConfirm(flowId, flowData) {
      this.selected_flows = [flowId];
      this.cbs_flow_list = [flowData];
      this.isConfirmButtonDisabled = false;
      this.cbs_flow_dialog_visible = false;
      this.$message.success('已选择流水');
    },
    // 打开CBS流水选择对话框
    openCbsFlowDialog() {
      this.cbs_flow_dialog_visible = true;
    },
    handleInvoiceInput(invoiceForm){
      this.invoice_select = true;
      this.invoiceForm = invoiceForm;
    },
    handleInvoiceSelect(val){
      if(this.invoice_select){
        this.$refs.moneyPay_invoiceFormRef.openInvoiceForm(this.pay_info.pid , this.pay_info.order)
      }
    },
    handleCloseInvoice(){
      this.invoice_select = false;
      this.invoiceForm = {};
    },
    sendInvoice(detailIds){
      // 转数组
      let orderDetailIds = detailIds.split(',');
      this.invoiceForm.orderDetailIds = orderDetailIds;
      this.invoiceForm.order_type = 'paid_order';
      this.$myhttp
        .post('admin/Invoice/issueInvoice', this.invoiceForm, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg + "\n 核销成功，但是开票失败，可以前往电子发票页面继续开票！");
            this.loading = false;
          }
          this.$emit('pay_finish' , detailIds);
        })
        .catch((err) => {
          this.$message.error(err + "\n 核销成功，但是开票失败，可以前往电子发票页面继续开票");
          this.loading = false;
        });
    },
    sendMoneyPay(){
      // 如果需要关联流水但未选择,阻止提交
      if (this.needAssociateFlow && this.selected_flows.length === 0) {
        this.$message.warning('请选择CBS银行流水');
        return;
      }

      // 将选中的flow_ids添加到pay_info
      if (this.selected_flows.length > 0) {
        this.pay_info.flow_ids = this.selected_flows.join(',');
      }

      this.loading = true;
        this.$myhttp.post('admin/OrderList/money_pay' , this.pay_info , {
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            if(backdata.data.code == 202){
              // CBS转账+流水场景：已提交待审核
              this.loading = false;
              this.$message.success(backdata.data.message || '已提交待审核');
              this.$emit('pay_finish' , null);
            }else if(backdata.data.code == 201){
              this.loading = false;
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '关闭',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => { })
            }else{
              let order_detail_ids = backdata.data.detail_id;
              if(this.invoice_select){
                // 继续开票
                this.$Message.success('核销成功，正在开票');
                this.sendInvoice(order_detail_ids);
              }else{
                this.$Message.success(backdata.data.message);
                this.loading = false;
                this.$emit('pay_finish' , order_detail_ids);
              }
            }
        },err=>{
          this.$Message.error('请求超时!');
        });
    },
    cancel(){
      this.visible = false;
      this.$emit('close');
    },
  },
  components : {
    ElectronicInvoiceForm : ElectronicInvoiceForm,
    CbsFlowDetail : CbsFlowDetail,
    CbsFlowSelector : CbsFlowSelector
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/moneyPay.vue